import React, { useState, useEffect, useReducer, useCallback, useContext } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
// import MessageModal from "../../components/MessageModal"
import KoraxFollowUpModal from "../../components/KoraxFollowUpModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import toastError from "../../errors/toastError";
import moment from "moment";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import usePlans from "../../hooks/usePlans";
import { Calendar,
  momentLocalizer } from "react-big-calendar";
import "moment/locale/pt-br";
import "react-big-calendar/lib/css/react-big-calendar.css";
import SearchIcon from "@material-ui/icons/Search";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import EventNoteIcon from "@material-ui/icons/EventNote";
import TodayIcon from "@material-ui/icons/Today";
import DateRangeIcon from "@material-ui/icons/DateRange";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import {
  KoraxPage,
  KoraxPageHeader
} from "../../components/KoraxUI";

import "./Schedules.css";

// Defina a função getUrlParam antes de usá-la
function getUrlParam(paramName) {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(paramName);
}

const localizer = momentLocalizer(moment);
var defaultMessages = {
  date: "Data",
  time: "Hora",
  event: "Follow-up",
  allDay: "Dia Todo",
  week: "Semana",
  work_week: "Follow-ups",
  day: "Dia",
  month: "Mês",
  previous: "Anterior",
  next: "Próximo",
  yesterday: "Ontem",
  tomorrow: "Amanhã",
  today: "Hoje",
  agenda: "Agenda",
  noEventsInRange: "Não há follow-ups no período.",
  showMore: function showMore(total) {
    return "+" + total + " mais";
  }
};

const reducer = (state, action) => {
  if (action.type === "LOAD_SCHEDULES") {
    const schedules = action.payload;
    const newSchedules = [];

    schedules.forEach((schedule) => {
      const scheduleIndex = state.findIndex((s) => s.id === schedule.id);
      if (scheduleIndex !== -1) {
        state[scheduleIndex] = schedule;
      } else {
        newSchedules.push(schedule);
      }
    });

    return [...state, ...newSchedules];
  }

  if (action.type === "UPDATE_SCHEDULES") {
    const schedule = action.payload;
    const scheduleIndex = state.findIndex((s) => s.id === schedule.id);

    if (scheduleIndex !== -1) {
      state[scheduleIndex] = schedule;
      return [...state];
    } else {
      return [schedule, ...state];
    }
  }

  if (action.type === "DELETE_SCHEDULE") {
    const scheduleId = action.payload;

    const scheduleIndex = state.findIndex((s) => s.id === scheduleId);
    if (scheduleIndex !== -1) {
      state.splice(scheduleIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  pageRoot: {
    paddingBottom: theme.spacing(8),
    gap: theme.spacing(1.5),

    background:
      theme.palette.type === "dark"
        ? "linear-gradient(145deg, #060D1A 0%, #0A1628 100%)"
        : "linear-gradient(145deg, #EBF3FF 0%, #F0F6FF 100%)"
  },
  hero: {
    flexShrink: 0, borderRadius: 24, padding: theme.spacing(2.4, 2.8),
    background: theme.palette.type === "dark"
      ? "linear-gradient(135deg, #071B4D 0%, #0D1F3C 100%)"
      : "linear-gradient(135deg, #FFFFFF 0%, #EAF3FF 55%, #F8FAFC 100%)",
    border: theme.palette.type === "dark"
      ? "1px solid rgba(0,140,255,0.18)" : "1px solid rgba(0,102,255,0.12)",
    boxShadow: "0 22px 55px rgba(0,102,255,.11)",
    display: "flex", alignItems: "center", justifyContent: "space-between",
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },
  heroLeft: { display: "flex", alignItems: "center", gap: theme.spacing(1.5) },
  heroIcon: {
    width: 48, height: 48, borderRadius: 14, flexShrink: 0, fontSize: "1.4rem",
    background: "linear-gradient(135deg, #0066FF 0%, #00A3FF 100%)",
    display: "flex", alignItems: "center", justifyContent: "center",
    boxShadow: "0 6px 16px rgba(0,102,255,0.3)",
  },
  heroTitle: {
    fontWeight: 950, fontSize: "1.45rem", letterSpacing: "-0.6px",
    color: theme.palette.type === "dark" ? "#ffffff" : "#0A1628",
  },
  heroSubtitle: {
    fontSize: "0.82rem", marginTop: 4, maxWidth: 620, lineHeight: 1.45,
    color: theme.palette.type === "dark" ? "rgba(255,255,255,0.5)" : "rgba(10,22,40,0.55)",
  },
  heroRight: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      "& button": { width: "100%" }
    }
  },
  heroChip: {
    background: theme.palette.type === "dark" ? "rgba(255,255,255,0.07)" : "rgba(255,255,255,0.9)",
    border: "1px solid rgba(0,102,255,0.15)",
    borderRadius: 10, fontWeight: 700, fontSize: "0.72rem",
    color: theme.palette.type === "dark" ? "rgba(255,255,255,0.7)" : "#0A1628",
  },
  addBtn: {
    borderRadius: 12, fontWeight: 700, fontSize: "0.82rem", textTransform: "none",
    background: "linear-gradient(135deg, #0066FF 0%, #00A3FF 100%)",
    color: "#fff", padding: theme.spacing(0.9, 2.5),
    boxShadow: "0 4px 14px rgba(0,102,255,0.28)",
    "&:hover": { background: "linear-gradient(135deg, #0052CC 0%, #007ACC 100%)" },
  },
  controlsBar: {
    flexShrink: 0, display: "flex", gap: theme.spacing(1.5), alignItems: "center",
  },
  searchField: {
    flex: 1,
    "& .MuiOutlinedInput-root": {
      borderRadius: 12, fontSize: "0.82rem",
      background: theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "#ffffff",
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#0066FF" },
    },
  },
  pageHeader: {
    width: "100%",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: 16,
    color: "#1e2a44",
    background: "#EDF4FF",
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.06)",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1.5),
    },
  },
  pageHeaderTitle: {
    fontWeight: 600,
    letterSpacing: 0.1,
    fontSize: "1.2rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.05rem",
    },
  },
  pageHeaderSubtitle: {
    marginTop: theme.spacing(0.25),
    color: "rgba(30,42,68,0.78)",
    fontSize: "0.8rem",
    lineHeight: 1.35,
  },
  headerChip: {
    backgroundColor: "#EAF1FF",
    color: "#2f4b7c",
    border: "1px solid #d7e5ff",
    fontWeight: 500,
    fontSize: "0.72rem",
    height: 24,
  },
  controlsPaper: {
    marginBottom: theme.spacing(2),
    borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 8px 22px rgba(15, 23, 42, 0.08)",
    padding: theme.spacing(1.25),
    backgroundColor: theme.palette.background.paper,
  },
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      backgroundColor: theme.palette.background.default,
    },
    "& .MuiInputBase-input": {
      fontSize: "0.82rem",
      paddingTop: 13,
      paddingBottom: 13,
    },
  },
  actionButton: {
    minHeight: 42,
    borderRadius: 10,
    fontWeight: 600,
    fontSize: "0.75rem",
    padding: theme.spacing(0.8, 1.4),
    boxShadow: "0 6px 14px rgba(7, 64, 171, 0.14)",
  },
  mainPaper: {
    minWidth: 0,
    flex: 1,
    padding: theme.spacing(1),
    overflow: "hidden",
    ...theme.scrollbarStyles,
    borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 12px 26px rgba(17, 24, 39, 0.09)",
  },
  calendarWrap: {
    minHeight: 700,
    minHeight: 580,
    padding: theme.spacing(1),
    borderRadius: 14,
    background:
      theme.mode === "light"
        ? "linear-gradient(180deg, #f8fbff 0%, #f4f8ff 100%)"
        : "linear-gradient(180deg, #0f172a 0%, #111827 100%)",
    border: `1px solid ${theme.palette.divider}`,
    "& .rbc-calendar": {
      fontSize: "0.82rem",
      color: theme.palette.text.primary,
      fontFamily: "'Poppins', 'Segoe UI', sans-serif",
    },
    "& .rbc-toolbar": {
      marginBottom: theme.spacing(1.25),
      gap: theme.spacing(1),
      flexWrap: "wrap",
      padding: theme.spacing(1),
      borderRadius: 12,
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor:
        theme.mode === "light" ? "rgba(255,255,255,0.8)" : "rgba(15,23,42,0.64)",
    },
    "& .rbc-toolbar .rbc-toolbar-label": {
      fontWeight: 700,
      letterSpacing: 0.2,
      fontSize: "0.95rem",
      color: theme.palette.text.primary,
    },
    "& .rbc-toolbar .rbc-btn-group button": {
      borderRadius: 10,
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor:
        theme.mode === "light" ? "rgba(255,255,255,0.92)" : "rgba(30,41,59,0.75)",
      color: theme.palette.text.primary,
      fontWeight: 600,
      boxShadow: "none",
      transition: "all 0.18s ease",
    },
    "& .rbc-toolbar .rbc-btn-group button:hover": {
      backgroundColor:
        theme.mode === "light" ? "rgba(239,246,255,1)" : "rgba(51,65,85,0.9)",
      borderColor: theme.palette.primary.main,
    },
    "& .rbc-toolbar .rbc-btn-group button.rbc-active": {
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      color: "#ffffff",
      boxShadow:
        theme.mode === "light"
          ? "0 8px 18px rgba(37, 99, 235, 0.28)"
          : "0 8px 18px rgba(2, 6, 23, 0.45)",
    },
    "& .rbc-month-view, & .rbc-time-view, & .rbc-agenda-view": {
      borderRadius: 12,
      overflow: "hidden",
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor:
        theme.mode === "light" ? "rgba(255,255,255,0.95)" : "rgba(15,23,42,0.7)",
    },
    "& .rbc-header": {
      padding: theme.spacing(0.8, 0.5),
      fontWeight: 700,
      fontSize: "0.75rem",
      letterSpacing: 0.35,
      textTransform: "uppercase",
      color: theme.palette.text.secondary,
      backgroundColor:
        theme.mode === "light" ? "rgba(248,250,252,0.95)" : "rgba(15,23,42,0.95)",
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    "& .rbc-date-cell": {
      padding: theme.spacing(0.45),
    },
    "& .rbc-date-cell button": {
      fontWeight: 600,
      color: theme.palette.text.secondary,
      borderRadius: 8,
      padding: theme.spacing(0.2, 0.6),
    },
    "& .rbc-today": {
      backgroundColor:
        theme.mode === "light" ? "rgba(219, 234, 254, 0.45)" : "rgba(30, 58, 138, 0.22)",
    },
    "& .rbc-off-range-bg": {
      backgroundColor:
        theme.mode === "light" ? "rgba(248,250,252,0.7)" : "rgba(2,6,23,0.35)",
    },
    "& .rbc-month-row + .rbc-month-row": {
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    "& .rbc-day-bg + .rbc-day-bg": {
      borderLeft: `1px solid ${theme.palette.divider}`,
    },
    "& .rbc-time-content, & .rbc-time-header-content": {
      borderLeft: `1px solid ${theme.palette.divider}`,
    },
  },

  followupQuickCards: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: theme.spacing(1.5),
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(2, 1fr)"
    }
  },
  followupQuickCard: {
    minHeight: 78,
    boxSizing: "border-box",
    borderRadius: 16,
    padding: "11px 13px",
    display: "flex",
    alignItems: "center",
    gap: 11,
    position: "relative",
    overflow: "hidden",
    background:
      theme.palette.type === "dark"
        ? "rgba(15,23,42,.92)"
        : "#FFFFFF",
    border: `1px solid ${theme.palette.divider}`,
    boxShadow:
      theme.palette.type === "dark"
        ? "0 8px 24px rgba(0,0,0,.22)"
        : "0 7px 20px rgba(15,23,42,.05)",
    transition: "transform .18s ease, box-shadow .18s ease",

    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow:
        theme.palette.type === "dark"
          ? "0 12px 28px rgba(0,0,0,.28)"
          : "0 11px 26px rgba(15,23,42,.075)"
    },

    [theme.breakpoints.down("sm")]: {
      minHeight: 74,
      padding: "10px",
      gap: 9
    }
  },

  followupMetricIcon: {
    width: 40,
    height: 40,
    flexShrink: 0,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#FFFFFF",
    boxShadow: "0 7px 16px rgba(15,23,42,.14)",

    "& svg": {
      fontSize: 20
    },

    [theme.breakpoints.down("sm")]: {
      width: 36,
      height: 36,
      borderRadius: 11,

      "& svg": {
        fontSize: 18
      }
    }
  },

  followupMetricContent: {
    minWidth: 0
  },

  followupMetric: {
    color: theme.palette.text.primary,
    fontSize: "1.22rem",
    fontWeight: 900,
    lineHeight: 1
  },

  followupLabel: {
    marginTop: 5,
    color: theme.palette.text.secondary,
    fontSize: ".66rem",
    fontWeight: 750,
    lineHeight: 1.2
  },
  followupLayout: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) 330px",
    gap: theme.spacing(1.5),
    alignItems: "stretch",
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr"
    }
  },
  sidebar: {
    borderRadius: 18,
    padding: theme.spacing(2),
    background: "#FFFFFF",
    border: "1px solid rgba(0,102,255,0.10)",
    boxShadow: "0 12px 28px rgba(15,23,42,0.06)",
    minHeight: 420
  },
  sidebarTitle: {
    fontWeight: 950,
    fontSize: "1rem",
    color: "#0A1628",
    marginBottom: theme.spacing(0.5)
  },
  sidebarSub: {
    fontSize: "0.74rem",
    color: "#64748B",
    marginBottom: theme.spacing(1.5)
  },
  scheduleItem: {
    padding: theme.spacing(1.2),
    borderRadius: 14,
    border: "1px solid #E2E8F0",
    background: "linear-gradient(180deg,#FFFFFF 0%,#F8FAFC 100%)",
    marginBottom: theme.spacing(1),
    cursor: "pointer",
    transition: "all .18s ease",
    "&:hover": {
      borderColor: "#93C5FD",
      transform: "translateY(-1px)",
      boxShadow: "0 8px 18px rgba(37,99,235,0.10)"
    }
  },
  scheduleName: {
    fontWeight: 900,
    fontSize: "0.84rem",
    color: "#0F172A"
  },
  scheduleDate: {
    fontSize: "0.72rem",
    color: "#64748B",
    marginTop: 4
  },
  emptySidebar: {
    borderRadius: 14,
    padding: theme.spacing(2),
    textAlign: "center",
    background: "#F8FAFC",
    color: "#64748B",
    fontSize: "0.82rem",
    fontWeight: 700
  },

  calendarToolbar: {
    "& .rbc-event": {
      border: "none",
      borderRadius: 10,
      background:
        theme.mode === "light"
          ? "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)"
          : "linear-gradient(135deg, #38bdf8 0%, #0ea5e9 100%)",
      boxShadow:
        theme.mode === "light"
          ? "0 8px 18px rgba(37, 99, 235, 0.3)"
          : "0 8px 18px rgba(2, 132, 199, 0.35)",
      color: "#ffffff",
      padding: theme.spacing(0.45, 0.55),
    },
    "& .rbc-event:focus": {
      outline: "none",
    },
    "& .rbc-show-more": {
      color: theme.palette.primary.main,
      fontWeight: 700,
    },
  },
}));

const Schedules = () => {
  const classes = useStyles();
  const history = useHistory();

  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);


  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [deletingSchedule, setDeletingSchedule] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [schedules, dispatch] = useReducer(reducer, []);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [contactId, setContactId] = useState(+getUrlParam("contactId"));

  // KORAX: tela de Follow-up liberada
  // para todos os usuarios autenticados.

  const fetchSchedules = useCallback(async () => {
    try {
      const { data } = await api.get("/schedules", {
        params: { searchParam, pageNumber },
      });

      dispatch({ type: "LOAD_SCHEDULES", payload: data.schedules });
      setHasMore(data.hasMore);
      setLoading(false);
    } catch (err) {
      toastError(err);
    }
  }, [searchParam, pageNumber]);

  const handleOpenScheduleModalFromContactId = useCallback(() => {
    if (contactId) {
      handleOpenScheduleModal();
    }
  }, [contactId]);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      fetchSchedules();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    searchParam,
    pageNumber,
    contactId,
    fetchSchedules,
    handleOpenScheduleModalFromContactId,
  ]);

  useEffect(() => {
    // handleOpenScheduleModalFromContactId();
    // const socket = socketManager.GetSocket(user.companyId, user.id);


    const onCompanySchedule = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_SCHEDULES", payload: data.schedule });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_SCHEDULE", payload: +data.scheduleId });
      }
    }

    socket.on(`company${user.companyId}-schedule`, onCompanySchedule)

    return () => {
      socket.off(`company${user.companyId}-schedule`, onCompanySchedule)
    };
  }, [socket, user.companyId]);

  const cleanContact = () => {
    setContactId("");
  };

  const handleOpenScheduleModal = () => {
    setSelectedSchedule(null);
    setScheduleModalOpen(true);
  };

  const handleCloseScheduleModal = () => {
    setSelectedSchedule(null);
    setScheduleModalOpen(false);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleEditSchedule = (schedule) => {
    setSelectedSchedule(schedule);
    setScheduleModalOpen(true);
  };

  const handleDeleteSchedule = async (scheduleId) => {
    try {
      await api.delete(`/schedules/${scheduleId}`);
      toast.success(i18n.t("schedules.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingSchedule(null);
    setSearchParam("");
    setPageNumber(1);

    dispatch({ type: "RESET" });
    setPageNumber(1);
    await fetchSchedules();
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  const todaySchedules = schedules.filter(s => moment(s.sendAt).isSame(moment(), "day"));
  const upcomingSchedules = schedules.filter(s => moment(s.sendAt).isAfter(moment()));
  const next7Schedules = schedules.filter(s =>
    moment(s.sendAt).isAfter(moment()) &&
    moment(s.sendAt).isBefore(moment().add(7, "days"))
  );
  const overdueSchedules = schedules.filter(s => moment(s.sendAt).isBefore(moment()));

  const nextSchedules = [...upcomingSchedules]
    .sort((a, b) => new Date(a.sendAt) - new Date(b.sendAt))
    .slice(0, 10);

  const getEventStatus = schedule => {
    if (moment(schedule.sendAt).isBefore(moment())) return "overdue";
    if (moment(schedule.sendAt).isSame(moment(), "day")) return "today";
    return "future";
  };

  const eventStyleGetter = event => {
    const status = event.resource?.statusView || "future";
    const colors = {
      overdue: { bg: "linear-gradient(135deg,#EF4444,#DC2626)", shadow: "rgba(239,68,68,.25)" },
      today: { bg: "linear-gradient(135deg,#F59E0B,#F97316)", shadow: "rgba(245,158,11,.25)" },
      future: { bg: "linear-gradient(135deg,#0066FF,#00A3FF)", shadow: "rgba(0,102,255,.25)" }
    };
    const color = colors[status] || colors.future;
    return {
      style: {
        background: color.bg,
        borderRadius: 10,
        color: "#fff",
        border: "none",
        boxShadow: `0 8px 18px ${color.shadow}`,
        fontWeight: 800
      }
    };
  };

  return (
    <KoraxPage className={classes.pageRoot}>
      <ConfirmationModal
        title={
          deletingSchedule &&
          `${i18n.t("schedules.confirmationModal.deleteTitle")}`
        }
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={() => handleDeleteSchedule(deletingSchedule.id)}
      >
        {i18n.t("schedules.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      {scheduleModalOpen && (
        <KoraxFollowUpModal
          open={scheduleModalOpen}
          onClose={handleCloseScheduleModal}
          reload={fetchSchedules}
          scheduleId={selectedSchedule ? selectedSchedule.id : null}
          contactId={contactId}
          cleanContact={cleanContact}
        />
      )}
      <KoraxPageHeader
        title="Follow-up"
        subtitle="Gerencie retornos, reengajamentos e oportunidades comerciais em um único calendário."
        actions={
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenScheduleModal}
            startIcon={<AddIcon />}
            className={classes.addBtn}
          >
            Novo Follow-up
          </Button>
        }
      />

      {/* BUSCA */}
      <div className={classes.controlsBar}>
        <TextField
          placeholder={i18n.t("contacts.searchPlaceholder")}
          type="search"
          value={searchParam}
          onChange={handleSearch}
          variant="outlined"
          size="small"
          className={classes.searchField}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon style={{ color: "#0066FF", fontSize: 18 }} />
              </InputAdornment>
            ),
          }}
        />
      </div>
      <div className={classes.followupQuickCards}>
        <div className={classes.followupQuickCard}>
          <div
            className={classes.followupMetricIcon}
            style={{
              background: "linear-gradient(135deg,#2563EB,#0EA5E9)"
            }}
          >
            <EventNoteIcon />
          </div>

          <div className={classes.followupMetricContent}>
            <div className={classes.followupMetric}>
              {schedules.length}
            </div>
            <div className={classes.followupLabel}>
              Agendados
            </div>
          </div>
        </div>

        <div className={classes.followupQuickCard}>
          <div
            className={classes.followupMetricIcon}
            style={{
              background: "linear-gradient(135deg,#F59E0B,#F97316)"
            }}
          >
            <TodayIcon />
          </div>

          <div className={classes.followupMetricContent}>
            <div className={classes.followupMetric}>
              {todaySchedules.length}
            </div>
            <div className={classes.followupLabel}>
              Para hoje
            </div>
          </div>
        </div>

        <div className={classes.followupQuickCard}>
          <div
            className={classes.followupMetricIcon}
            style={{
              background: "linear-gradient(135deg,#16A34A,#22C55E)"
            }}
          >
            <DateRangeIcon />
          </div>

          <div className={classes.followupMetricContent}>
            <div className={classes.followupMetric}>
              {next7Schedules.length}
            </div>
            <div className={classes.followupLabel}>
              Próximos 7 dias
            </div>
          </div>
        </div>

        <div className={classes.followupQuickCard}>
          <div
            className={classes.followupMetricIcon}
            style={{
              background: "linear-gradient(135deg,#DC2626,#F43F5E)"
            }}
          >
            <WarningRoundedIcon />
          </div>

          <div className={classes.followupMetricContent}>
            <div className={classes.followupMetric}>
              {overdueSchedules.length}
            </div>
            <div className={classes.followupLabel}>
              Atrasados
            </div>
          </div>
        </div>
      </div>

      <div className={classes.followupLayout}>
        <Paper className={classes.mainPaper} variant="outlined" onScroll={handleScroll}>
          <div className={`${classes.calendarWrap} schedule-calendar`}>
            <Calendar
            messages={defaultMessages}
            formats={{
              agendaDateFormat: "DD/MM ddd",
              weekdayFormat: "dddd"
            }}
            localizer={localizer}
            events={schedules.map((schedule) => ({
              title: (
                <div key={schedule.id} className="event-container">
                  <div className="event-title">⚡ {schedule?.contact?.name || "Contato"}</div>
                  <DeleteOutlineIcon
                    onClick={() => handleDeleteSchedule(schedule.id)}
                    className="delete-icon"
                  />
                  <EditIcon
                    onClick={() => {
                      handleEditSchedule(schedule);
                      setScheduleModalOpen(true);
                    }}
                    className="edit-icon"
                  />
                </div>
              ),
              start: new Date(schedule.sendAt),
              end: new Date(schedule.sendAt),
              resource: { ...schedule, statusView: getEventStatus(schedule) }
            }))}
            startAccessor="start"
            endAccessor="end"
            eventPropGetter={eventStyleGetter}
            style={{ height: 700 }}
            className={classes.calendarToolbar}
          />
          </div>
        </Paper>

        <div className={classes.sidebar}>
          <Typography className={classes.sidebarTitle}>⚡ Próximos Follow-ups</Typography>
          <Typography className={classes.sidebarSub}>
            Priorize os retornos que ainda vão acontecer.
          </Typography>

          {nextSchedules.length === 0 ? (
            <div className={classes.emptySidebar}>
              Nenhum follow-up futuro encontrado.
            </div>
          ) : (
            nextSchedules.map(schedule => (
              <div
                key={schedule.id}
                className={classes.scheduleItem}
                onClick={() => handleEditSchedule(schedule)}
              >
                <Typography className={classes.scheduleName}>
                  {schedule?.contact?.name || "Contato sem nome"}
                </Typography>
                <Typography className={classes.scheduleDate}>
                  {moment(schedule.sendAt).calendar(null, {
                    sameDay: "[Hoje às] HH:mm",
                    nextDay: "[Amanhã às] HH:mm",
                    nextWeek: "dddd [às] HH:mm",
                    sameElse: "DD/MM/YYYY [às] HH:mm"
                  })}
                </Typography>
                <div style={{ marginTop: 8, display: "flex", gap: 6, flexWrap: "wrap" }}>
                  <span style={{ fontSize: 11, fontWeight: 900, color: "#0066FF", background: "rgba(0,102,255,.08)", padding: "4px 8px", borderRadius: 999 }}>
                    Mensagem programada
                  </span>
                  {schedule?.contact?.number && (
                    <span style={{ fontSize: 11, fontWeight: 900, color: "#64748B", background: "#F1F5F9", padding: "4px 8px", borderRadius: 999 }}>
                      {schedule.contact.number}
                    </span>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </KoraxPage>
  );
};

export default Schedules;
